import { gql } from '@apollo/client';

export const DASHBOARD_SUMMARY_QUERY = gql`
  query DashboardSummary($date: DateTime, $branch_id: ID) {
    dashboardSummary(date: $date, branch_id: $branch_id) {
      date
      branch_id
      sales_count
      sales_total_cents
      paid_total_cents
      pending_total_cents
      open_account_total_cents
      cancelled_sales_count
      cancelled_sales_total_cents
      discounts_total_cents
      cash_in_total_cents
      cash_out_total_cents
      open_shifts_count
      pending_tickets_count
      occupied_consulting_rooms_count
      waiting_patients_count
      open_accounts_count
      open_accounts_balance_cents
    }
  }
`;

export const SALES_DAY_PAYMENT_METHOD_BREAKDOWN_QUERY = gql`
  query SalesDayPaymentMethodBreakdown($date: DateTime, $branch_id: ID) {
    salesDayPaymentMethodBreakdown(date: $date, branch_id: $branch_id) {
      payment_method_id
      payment_method_code
      payment_method_name
      payments_count
      total_cents
    }
  }
`;

export const SALES_REPORT_CATEGORIES_QUERY = gql`
  query SalesReportCategories {
    salesReportCategories {
      id
      name
      sort_order
    }
  }
`;

export const SALES_BY_CATEGORY_REPORT_QUERY = gql`
  query SalesByCategoryReport($from: DateTime!, $to: DateTime!, $category_id: ID) {
    salesByCategoryReport(from: $from, to: $to, category_id: $category_id) {
      summary {
        total_cents
        tickets_count
        avg_ticket_cents
        categories_total_cents
      }
      columns {
        column_key
        category_id
        category_name
        sort_order
      }
      rows {
        sale_order_id
        paid_at
        sale_folio_number
        ticket_folio_number
        sale_status
        paid_cents
        pending_cents
        open_account_id
        pet_name
        payment_methods {
          payment_method_id
          payment_method_code
          payment_method_name
          amount_cents
          sort_order
        }
        cells {
          column_key
          amount_cents
        }
      }
    }
  }
`;

export const SALES_BY_VET_QUERY = gql`
  query SalesByVet($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    salesByVet(from: $from, to: $to, branch_id: $branch_id) {
      veterinarian_id
      full_name
      sales_count
      total_cents
    }
  }
`;

export const CANCELLATIONS_RANGE_QUERY = gql`
  query CancellationsRange($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    cancellationsRange(from: $from, to: $to, branch_id: $branch_id) {
      id
      folio_number
      total_cents
      cancel_reason_id
      cancel_note
      cancelled_by
      cancelled_at
      customer_snapshot_json
    }
  }
`;

export const DISCOUNTS_RANGE_QUERY = gql`
  query DiscountsRange($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    discountsRange(from: $from, to: $to, branch_id: $branch_id) {
      id
      actor_user_id
      reference_id
      reference_kind
      amount_cents
      reason
      metadata_json
      created_at
    }
  }
`;

export const CASH_OUTS_RANGE_QUERY = gql`
  query CashOutsRange($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    cashOutsRange(from: $from, to: $to, branch_id: $branch_id) {
      id
      cash_shift_id
      branch_id
      amount_cents
      reason
      performed_by
      created_at
    }
  }
`;

export const CASH_DIFFERENCES_RANGE_QUERY = gql`
  query CashDifferencesRange($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    cashDifferencesRange(from: $from, to: $to, branch_id: $branch_id) {
      id
      cash_shift_id
      performed_by
      expected_cash_cents
      declared_cash_cents
      difference_cents
      created_at
    }
  }
`;

export const SUSPICIOUS_MOVEMENTS_QUERY = gql`
  query SuspiciousMovements($from: DateTime!, $to: DateTime!, $branch_id: ID) {
    suspiciousMovements(from: $from, to: $to, branch_id: $branch_id) {
      kind
      reference_id
      actor_user_id
      amount_cents
      occurred_at
      detail
    }
  }
`;
